<script>
  import LyricStatus from './lib/LyricStatus.svelte';
  import PlayerScreen from './lib/PlayerScreen.svelte';
  import SearchList from './lib/SearchList.svelte';
	import { onMount } from 'svelte';

  // Configuration file
  const configUrl = new URL('./data/config.json', window.location.href);
	let config = $state(null);
  let serverUrl = $state(null);

  // Currently-selected collection / paper / song
	let currentCollection = $state(null);
  let currentId = $state(null);
  let currentPaper = $state(null);
  let currentSong = $state(null);

  let loaded = $state(false);
  let lyricsData = $state(null);
  let liveLyricsData = $state(null);
  let papersData = $state(null);
  let songsData = $state(null);

  let systemTitle = 'KaraokAI.tech';
  let authStatus = $state('');

  let passkey = $state(null);
  passkey = localStorage.getItem("passkey") || '';
  let authTest = '';
  $effect(() => {
    if (passkey && serverUrl) {
      (async () => {
        console.log('Auth test...');
        authTest = await testAuth();
        authStatus = (authTest ? ((passkey && passkey.endsWith('!')) ? ' 🌟' : ' ✨') : '');
        console.log('Auth status...' + authStatus);
      })();
    }
  });

  let recentRequest = $state(null);
  let requestedTheseLyrics = $derived.by(() => {
    let recentResponse = recentRequest && Object.values(recentRequest).length > 0 ? Object.values(recentRequest)[0] : null;
    if (recentResponse && currentPaper && currentSong) {
      if (recentResponse.paper == currentPaper && recentResponse.song == currentSong) {
        return {
          queued: recentResponse.queued,
          id: recentResponse.id,
        }
      }
    }
    return false;
  });
  
  const addAuth = (url) => {
    if (passkey) {
      //url.username = '';
      //url.password = passkey;
      // Quick hack!
      let key = passkey;
      if (key.endsWith('!')) {
        key = key.slice(0, -1);
      }
      url = url.toString() + '?key=' + encodeURIComponent(key);
    }
    return url;
  };

  onMount(() => {
    // Passkey
    const passkeyDialog = document.getElementById('passkey-dialog');
    passkeyDialog.addEventListener('close', () => {
      // @ts-ignore
      const result = passkeyDialog.returnValue;
      if (result === 'default') {
        const passkeyInput = document.getElementById('passkey');
        // @ts-ignore
        const newPasskey = passkeyInput.value;
        // @ts-ignore
        passkeyInput.value = '';
        if (newPasskey != passkey) {
          localStorage.setItem("passkey", newPasskey);
          passkey = newPasskey;
          setTimeout(() => {
            console.log('Reloading page (new passkey)...');
            window.location.reload();
          }, 200);
        }
      }
    });
  });

  // Click to open passkey
  let lastClick = null;
  let clickCount = 0;
  function passkeyClickHandler() {
    const now = Date.now();
    if (lastClick && now - lastClick < 1000) {
      clickCount++;
      if (clickCount === 3) {
        // @ts-ignore
        document.getElementById('passkey-dialog').showModal();
      }
    } else {
      clickCount = 1;
    }
    lastClick = now;
  }

  async function testAuth() {
    const url = new URL('test', serverUrl);
    const data = {
      key: passkey.endsWith('!') ? passkey.slice(0, -1) : passkey,
    };
    const options = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
      },
      body: JSON.stringify(data),
      credentials: "include",
    };
    // if (passkey) {
    //   options.headers['Authorization'] = 'Bearer ' + (passkey.endsWith('!') ? passkey.slice(0, -1) : passkey);
    // }
    let response = null;
    try {
      // @ts-ignore
      response = await fetch(url, options);
    } catch (e) {
      console.error('NOTE: Error fetching auth test', e);
    }
    if (!response || !response.ok) {
      return null;
    }
    const responseData = await response.json();
    return responseData;
  }

  async function requestNewLyrics(currentPaper, currentSong) {
    if (!currentPaper || !currentSong) {
      return;
    }
    const url = new URL(currentCollection + '/request', serverUrl);
    const data = {
      paper: currentPaper,
      song: currentSong,
      key: passkey.endsWith('!') ? passkey.slice(0, -1) : passkey,
    };
    const options = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
      },
      body: JSON.stringify(data),
      credentials: "include",
    };
    // if (passkey) {
    //   options.headers['Authorization'] = 'Bearer ' + (passkey.endsWith('!') ? passkey.slice(0, -1) : passkey);
    // }
    // @ts-ignore
    const response = await fetch(url, options);
    if (!response.ok) {
      throw new Error('Failed to request new lyrics');
    }
    const responseData = await response.json();
    return responseData;
  }

  async function commandNavigate() {
    const url = new URL(currentCollection + '/navigate', serverUrl);
    const data = {
      collection: currentCollection,
      paper: currentPaper,
      song: currentSong,
      id: currentId,
      key: passkey.endsWith('!') ? passkey.slice(0, -1) : passkey,
    };
    //if (currentCollection) data.collection = currentCollection;
    if (currentPaper) data.paper = currentPaper;
    if (currentSong) data.song = currentSong;
    if (currentId) data.id = currentId;
    const options = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
      },
      body: JSON.stringify(data),
      credentials: "include",
    };
    // if (passkey) {
    //   options.headers['Authorization'] = 'Bearer ' + (passkey.endsWith('!') ? passkey.slice(0, -1) : passkey);
    // }
    // @ts-ignore
    const response = await fetch(url, options);
    if (!response.ok) {
      throw new Error('Failed to post command navigate');
    }
    const responseData = await response.json();
    return responseData;
  }

  let isQueued = $derived.by(() => {
    if (currentPaper && currentSong && liveLyricsData) {
      for (const key of Object.keys(liveLyricsData)) {
        if (liveLyricsData[key].queued && 
        // TODO: Fix terrible field name mismatch
        (liveLyricsData[key].paper == currentPaper || liveLyricsData[key].paperId == currentPaper) && 
        (liveLyricsData[key].song == currentSong || liveLyricsData[key].songId == currentSong)
      ) {
          return true; //liveLyricsData[key];
        }
      }
    }
    return false;
  });


  // TODO: Redo to only add if missing
  let combinedLyricsData = $state({});
  $effect(() => {
    if (loaded) {
      // Sorted lyrics alphabetically
      let allKeys = Object.keys(lyricsData);
      if (liveLyricsData) {
        const liveKeys = Object.keys(liveLyricsData).filter(key => 
          !liveLyricsData[key].queued
        );
        allKeys = allKeys.concat(liveKeys);
      }
      const sortedKeys = allKeys.sort((a, b) => a.localeCompare(b));  // Oldest first as ID is a timestamp
      for (const key of sortedKeys) {
        let live = false;
        let lyrics;
        if (lyricsData[key]) {
          lyrics = lyricsData[key]
        } else if (liveLyricsData[key]) {
          lyrics = liveLyricsData[key];
          live = true;
        }
        if (!combinedLyricsData[key]) {
          // HACK: These live types don't fully match?
          const lyricsId = lyrics.id || lyrics.lyricId;
          const lyricPaper = papersData[lyrics.paper || lyrics.paperId];
          const lyricSong = songsData[lyrics.song || lyrics.songId];
          const paperTitle = lyricPaper ? lyricPaper.title : '';
          const paperAuthors = lyricPaper ? lyricPaper.authors : '';
          const songArtist = lyricSong ? lyricSong.artist : '';
          const songTitle = lyricSong ? lyricSong.title : '';
          combinedLyricsData[key] = {
            id: lyricsId,
            title: paperTitle,
            subtitle: paperAuthors,
            description: '🎵 ' + songArtist + ' — ' + songTitle,
            paperTitle,
            paperAuthors,
            songArtist,
            songTitle,
            paper: lyrics.paper || lyrics.paperId,
            song: lyrics.song || lyrics.songId,
            modified: lyrics.modified,
            live: live,
          };
        }
      }
    }
	});

  let orderedLyricsData = $derived.by(() => {
    if (combinedLyricsData) {
      const sortedKeys = Object.keys(combinedLyricsData).reverse();
      const sortedData = {};
      for (const key of sortedKeys) {
        sortedData[key] = combinedLyricsData[key];
      }
      return sortedData;
    }
    return null;
  });

  let lyricDataUrl = $derived.by(() => {
    let url = null;
    if (currentCollection && currentId) {
      const key = Object.keys(combinedLyricsData).find(k => combinedLyricsData[k].id == currentId);
      if (key) {
        if (combinedLyricsData[key].live) {
          url = new URL(currentCollection + '/' + key, serverUrl).toString();
          console.log('Lyric URL live: ' + url);
        } else {
          url = new URL(key, new URL(config.collections[currentCollection].lyrics, configUrl)).toString();
          console.log('Lyric URL: ' + url);
        }
      }
    }
    return url;
  });

  let loadedLyricData = $state(null);
  let lyricDataStatus = $state(null);
  let loadedLyricDataUrl = null;
  $effect(() => {
    if (lyricDataUrl != loadedLyricDataUrl) {
      console.log('Lyric URL changed: ' + loadedLyricDataUrl + ' -> ' + lyricDataUrl);
      loadedLyricDataUrl = lyricDataUrl;
      if (lyricDataUrl) {
        lyricDataStatus = 'loading';
        fetch(lyricDataUrl, { credentials: "include" }).then((lyricReq) => {
          if (!lyricReq.ok) {
            throw new Error('Failed to fetch lyrics data');
          }
          loadedLyricData = null;
          lyricReq.json().then((data) => {
            loadedLyricData = data;

            // Generate .lyrics format

            //"generated": [{"timestamp": "00:19-00:23","lyric": "4:A | Hum... hum... hum... hum"},]


            const lyrics = [];
            const lyricsMap = {};
            let index = 0;
            for (const line of data.generated) {
              const timeRange = line.timestamp.split('-').map(t => t.split(':').map(x => parseFloat(x)).reduce((acc, val) => acc * 60 + val), 0);
              lyricsMap[line.timestamp] = index++;
              let text = line.lyric;
              if (text.includes('|')) {
                const parts = text.split('|');
                parts.shift();
                text = parts.join('|').trim();;
              }
              lyrics[lyricsMap[line.timestamp]] = {
                startTime: timeRange[0],
                endTime: timeRange[1],
                text,
                original: null,
              }
            }
            for (const line of data.original) {
              let text = line.lyric;
              if (lyricsMap[line.timestamp] != null) {
                if (text.includes('|')) {
                  const parts = text.split('|');
                  parts.shift();
                  text = parts.join('|').trim();;
                }
                lyrics[lyricsMap[line.timestamp]].original = text;
              }
            }
            loadedLyricData.lyrics = lyrics;
            lyricDataStatus = null;

          }).catch((e) => {
            console.error('Error parsing lyrics data', e);
            loadedLyricData = null;
            lyricDataStatus = 'error';
          });
        }).catch((e) => {
          console.error('Error loading lyrics data', e);
          loadedLyricData = null;
          lyricDataStatus = 'error';
        });
      } else {
        loadedLyricData = null;
      }
    }
  });  


  /*
  async function loadLiveLyrics() {
    try {
      const liveLyricsReq = fetch(new URL(currentCollection + '/' + 'lyrics.json', serverUrl), {
        credentials: "include",
      });
      if (!(await liveLyricsReq).ok) { throw new Error('Failed to fetch lyrics data'); }
      liveLyricsData = await (await liveLyricsReq).json();
    } catch (e) {
      console.error('ERROR: Problem loading live lyrics data: ', e);
      liveLyricsData = null;
    }
  }
  */

  let currentWsUrl = null;
  let ws = null;
  let wsPingValue = null;
  let wsPongValue = null;
  let wsPinger = null;
  function connectWebsocket(collectionId) {
    console.log('WS: Connecting to ' + collectionId);

    if (!collectionId || !serverUrl) return;

    const wsUrl = (new URL(collectionId + '/queue', serverUrl)).toString().replace(/^http/, 'ws');
    if (wsUrl != currentWsUrl) {
      currentWsUrl = wsUrl;

      if (ws) {
        // @ts-ignore
        ws.close();
        ws = null;
        if (wsPinger) {
          clearInterval(wsPinger);
          wsPinger = null;
        }
      }

      liveLyricsData = null;

      wsPingValue = 0;
      wsPongValue = 0;

      console.log('WS: Connecting: ' + wsUrl);
      ws = new WebSocket(wsUrl);
      ws.onopen = () => {
        console.log('WS: Open');
        wsPinger = setInterval(() => {
          if (ws.readyState === WebSocket.OPEN) {
            if (wsPingValue > wsPongValue + 4) {
              console.log('WS: Ping timeout');
              ws.close();
              ws = null;
              clearInterval(wsPinger);
              wsPinger = null;
            } else {
              ws.send(JSON.stringify({ type: 'ping', data: ++wsPingValue }));
            }
          }
        }, 15 * 1000);
      };
      ws.onmessage = (event) => {
        const message = JSON.parse(event.data);
        if (message.type === 'pong') {
          //console.log('WS: Message - pong');
          wsPongValue = message.data;
        } else if (message.type === 'init') {
          console.log('WS: Message - init');
          liveLyricsData = message.data;
        } else if (message.type === 'add') {
          console.log('WS: Message - add - ' + message.data.key + ' - ' + JSON.stringify(message.data.obj));
          //if (!message.data.obj.queued)
          liveLyricsData[message.data.key] = message.data.obj;
        } else if (message.type === 'del') {
          console.log('WS: Message - del - ' + message.data.key);
          //if (message.data.key in liveLyricsData)
          delete liveLyricsData[message.data.key];
        } else if (message.type === 'cmd') {
          if (passkey && passkey.endsWith('!')) {
            if (message.msg == 'navigate') {
              console.log('WS: Message - cmd - navigate');
              // message.data.body.{collection, paper, song, id}
              if ('collection' in message.body) params.set('collection', message.body.collection); else params.delete('collection');
              if ('paper' in message.body) params.set('paper', message.body.paper); else params.delete('paper');
              if ('song' in message.body) params.set('song', message.body.song); else params.delete('song');
              if ('id' in message.body) params.set('id', message.body.id); else params.delete('id');
              navigate(false, 'Remote command navigation');
            } else {
              console.log('WS: Message - cmd - UNKNOWN - ' + message.msg);
            }
          } else {
            // Ignore command
          }
        } else {
          console.log('WS: Unknown message type: ' + message.type);
        }
      };
      ws.onerror = (error) => {
        console.error('WS: Error: ', error);
      };
      ws.onclose = () => {
        console.log('WS: Closed');
      };
    }
  }


  async function loadData() {
    const lyricsReq = fetch(new URL(config.collections[currentCollection].lyrics, configUrl));
    const papersReq = fetch(new URL(config.collections[currentCollection].papers, configUrl));
    const songsReq = fetch(new URL(config.collections[currentCollection].songs, configUrl));
    if (!(await lyricsReq).ok) { throw new Error('Failed to fetch lyrics data'); }
    if (!(await papersReq).ok) { throw new Error('Failed to fetch papers data'); }
    if (!(await songsReq).ok) { throw new Error('Failed to fetch songs data'); }
    lyricsData = await (await lyricsReq).json();
    papersData = await (await papersReq).json();
    songsData = await (await songsReq).json();

    loaded = true;
  }

  // Track hash parameters
  let params = $state(null);
  function hashChanged() {
    const hash = window.location.hash;
    //console.log('HASH: ' + hash.substring(1));
    params = new URLSearchParams(hash.substring(1));
    let collection = params.get('collection');

    // If no/invalid collection is selected, change all parameters to the default collection
    if (collection === '') {
      currentCollection = ''; // Choose collection screen
    } else if (!collection || !config.collections[collection]) {
      params = new URLSearchParams();
      let defaultCollection = '';   // User selection screen
      // Find collection within range
      const now = (new Date()).getTime();
      for (const collectionId of Object.keys(config.collections)) {
        const collection = config.collections[collectionId];
        if (collection.start && collection.end && now >= new Date(collection.start).getTime() && now < new Date(collection.end).getTime()) {
          defaultCollection = collectionId;
        }
      }
      // Otherwise, choose latest collection
      // if (!defaultCollection && config.collections && Object.keys(config.collections).length > 0) {
      //   defaultCollection = Object.keys(config.collections).slice(-1)[0];
      // }
      params.set('collection', defaultCollection);
      navigate(false, 'Changing collection to default');
    } else {
      if (currentCollection != collection) {
        currentCollection = collection;
        loaded = false;
        loadData();
      }
      currentId = params.has('id') ? params.get('id') : null;
      currentPaper = params.has('paper') ? params.get('paper') : null;
      currentSong = params.has('song') ? params.get('song') : null;
    }

    connectWebsocket(currentCollection);
  }

  // Update hash parameters
  function navigate(replace, reason) {
    if (replace) {
      console.log('Navigate replace... ' + reason);
      window.location.replace(window.location.origin + window.location.pathname + window.location.search + '#' + params.toString());
    } else {
      console.log('Navigate setting hash... ' + reason);
      window.location.hash = params.toString();
    }
  }

  // State changes to be reflected in the hash
  $effect(() => {
    if (params) {
      // if (currentCollection != params.get('collection')) {
      //   params = new URLSearchParams();
      //   params.set('collection', currentCollection);
      //   navigate();
      // }
      if (currentPaper != null && currentPaper != params.get('paper')) {
        params.set('paper', currentPaper);
        params.delete('id');
        navigate(false, 'Changing paper');
        return;
      }
      if (currentSong != null && currentSong != params.get('song')) {
        params.set('song', currentSong);
        params.delete('id');
        navigate(false, 'Changing song');
        return;
      }
    }
    if (!currentId && currentPaper && currentSong) {
      // Find lyrics data for the current paper and song, and switch to it
      for (const key in combinedLyricsData) {
        const lyrics = combinedLyricsData[key];
//console.log('CHECKING: ', lyrics.paper, currentPaper, lyrics.song, currentSong, key);
//console.dir(combinedLyricsData[key])
        if (lyrics.paper == currentPaper && lyrics.song == currentSong) {
          params.set('id', lyrics.id);
          currentId = lyrics.id;
          navigate(true, 'Setting lyrics ID');
          return;
        }
      }
    }
    // Set the paper and song ID, if missing, to match the lyrics
    if (currentId && (!currentPaper || !currentSong)) {
      for (const lyrics of Object.values(combinedLyricsData)) {
        if (lyrics.id == currentId) {
          params.set('paper', lyrics.paper);
          params.set('song', lyrics.song);
          navigate(false, 'Setting paper/song from ID');
          return;
        }
      }
    }
  });

	onMount(async () => {
    // Fetch config
    const resConfig = await fetch(configUrl);
    if (!resConfig.ok) {
      throw new Error('Failed to fetch config');
    }
    config = await resConfig.json();

    // Server URL
    serverUrl = new URL(config.server || '', window.location.href);
    // If localhost or 127.0.0.1 or ::1
    if (window.location.hostname == 'localhost' || window.location.hostname == '127.0.0.1' || window.location.hostname == '::1') {
      serverUrl = new URL(config.local_server || '', window.location.href);
    }

    // Retrieve initial hash parameters and monitor for changes
    window.addEventListener('hashchange', hashChanged);
    hashChanged();

    //loadLiveLyrics();

	});

</script>

<main>

  {#if currentCollection === ''}

    <SearchList
      list={config.collections}
      primary='name'
      secondary='description'
      categories={({'name': 'Name', 'description': 'Description'})}
      suggest={({label:'All', value: '*'})}
      buttonSelected={(id) => {
        params = new URLSearchParams();
        params.set('collection', id);
        navigate(false, 'Changing collection');
      }}
      textPlaceholder="Filter..."
      textTitle={systemTitle + authStatus}
      textSubtitle="Choose data collection"
      textButtonBack={`🗙 Default Collection`}
      buttonBack={() => { 
        params.delete('collection'); 
        params.delete('paper');
        params.delete('song');
        params.delete('id');
        navigate(false, 'Clearing collection/paper/song/id to use default');
      }}
      textContinue={null}
    />    

  {:else if !loaded}

    <SearchList
      textPlaceholder={null}
      textTitle={systemTitle + authStatus}
      textSubtitle={`Loading ${config && config.collections && config.collections[currentCollection] ? config.collections[currentCollection].name : ''}...`}
      textContinue={null}
    />

  {:else}
  
    {#if !currentId && (currentPaper === null && currentSong === null) }

      <!-- textSubtitle="Recently generated lyrics" -->

      <SearchList
        list={orderedLyricsData}
        primary='title'
        secondary='subtitle'
        description='description'
        categories={({'paperTitle': 'Recent: Paper Title', 'paperAuthors': 'Recent: Author', 'songArtist': 'Recent: Artist', 'songTitle': 'Recent: Song Title'})}
        suggest={({label:'Recent', value: '*', limit: 75})}
        buttonSelected={(key) => {
          currentId = combinedLyricsData[key].id;
        }}
        textPlaceholder="Search already-generated lyrics by papers or songs..."
        textTitle={systemTitle + authStatus}
        textButtonAction="+ Generate New Lyrics"
        noMatchHint="Press 'Generate New Lyrics' to make a new combination."
        noItemsHint="Press 'Generate New Lyrics' to make a new combination."
        buttonAction={() => {
          params.set('paper', '');
          params.delete('id');
          navigate(false, 'Emptying paper to generate new lyrics');
        }}
        textButtonBack={`↻ ${config.collections[currentCollection].name}`}
        buttonBack={() => { 
          params.set('collection', ''); 
          params.delete('paper');
          params.delete('song');
          params.delete('id');
          navigate(false, 'Clearing collection/paper/song/id to change collection');
        }}
        textContinue={null}
        buttonPasskeyClick={passkeyClickHandler}
          doubleClick={() => {
            if (passkey) {
              console.log('Navigating home screen...');
              commandNavigate()
            }
          }}
      />

    {:else if !currentId && (currentPaper == '' || (currentSong && currentPaper == null))}

      <SearchList
        list={papersData}
        primary='title'
        secondary='authors'
        categories={({'title': 'Title', 'authors': 'Author', 'affiliations': 'Affiliation'})}
        suggest={
          Object.keys(papersData).length > 100
            ? ({label:'Best Papers', tag: 'award', value: 'BEST_PAPER'})
            : ({label:'All Papers'})
        }
        buttonSelected={(id) => {
          currentPaper = id;
        }}
        textPlaceholder="Search by title, author, or institution..."
        textTitle={"Choose a paper" + authStatus}
        textSubtitle="Select a paper to turn into song lyrics"
        noMatchHint="Use an author or institution name, or words from the title, from the current collection."
        textButtonBack="← Home"
        buttonBack={() => {
          params.delete('paper');
          params.delete('id');
          navigate(false, 'Clearing paper/id to go home');
        }}
        textContinue={null}
        buttonPasskeyClick={passkeyClickHandler}
      />

    {:else if !currentId && (currentSong == null || currentSong == '')}

      <SearchList
        list={songsData}
        primary='title'
        secondary='artist'
        categories={({'title': 'Title', 'artist': 'Artist'})}
        suggest={({label:'All Songs', value: '*'})}
        buttonSelected={(id) => {
          currentSong = id;
        }}
        textPlaceholder="Search by title or artist..."
        textTitle={"Choose a song" + authStatus}
        textSubtitle="Select which song you want to generate lyrics for"
        noMatchHint="Try another artist or song name."
        textButtonBack="← Change Paper"
        buttonBack={() => { 
          params.set('paper', ''); 
          params.delete('song');
          params.delete('id');
          navigate(false, 'Clearing song/id/paper to change paper');
        }}
        textContinue={null}
        buttonPasskeyClick={passkeyClickHandler}
      />

    {:else}

      {#if lyricDataStatus}

        <LyricStatus
          textTitle={ lyricDataStatus == 'loading' ? 'Loading...' : (lyricDataStatus == 'error' ? 'Error Loading Lyrics' : lyricDataStatus) }
          textSubtitle=""
          paperId={currentPaper}
          songId={currentSong}
          lyricId={currentId}
          paperTitle={currentPaper && papersData[currentPaper] ? papersData[currentPaper].title : '-'}
          paperAuthors={currentPaper && papersData[currentPaper] ? papersData[currentPaper].authors : '-'}
          songTitle={currentSong && songsData[currentSong] ? songsData[currentSong].title : '-'}
          songArtist={currentSong && songsData[currentSong] ? songsData[currentSong].artist : '-'}
          textButtonBack={'← Home'}
          buttonBack={() => {
            params.delete('id');
            params.delete('paper');
            params.delete('song');
            navigate(false, 'Clearing paper/song/id to go home from loading');
          }}
          buttonPasskeyClick={passkeyClickHandler}
        />


      {:else if !loadedLyricData}

        <LyricStatus
          textTitle={"New Lyrics" + authStatus}
          textSubtitle="Generate lyrics for a paper and song"
          collectionId={currentCollection}
          paperId={currentPaper}
          songId={currentSong}
          lyricId={currentId}
          paperTitle={currentPaper && papersData[currentPaper] ? papersData[currentPaper].title : '-'}
          paperAuthors={currentPaper && papersData[currentPaper] ? papersData[currentPaper].authors : '-'}
          songTitle={currentSong && songsData[currentSong] ? songsData[currentSong].title : '-'}
          songArtist={currentSong && songsData[currentSong] ? songsData[currentSong].artist : '-'}
          textButtonBack={params.has('id') ? '← Home' : '← Change Song'}
          buttonBack={() => {
            if (params.has('id')) {
              params.delete('id');
              params.delete('paper');
              params.delete('song');
            } else {
              params.set('song', ''); 
            }
            navigate(false, 'Clearing song/id/paper to change song');
          }}
          notes={
            isQueued
            ? 'Lyrics request is processing - please wait, it may take a while.'
            : requestedTheseLyrics
            ? 'Lyrics requested...'
            : !passkey
            ? 'Please ask a researcher at the demo booth to generate your chosen paper/song lyric combination, using the QR Code/details above.'
            : ''
          }
          showQRCode={!requestedTheseLyrics && !passkey}
          textContinue={requestedTheseLyrics ? 'Generating...' : (passkey ? 'Generate New Lyrics' : '')}
          buttonContinue={async () => {
            recentRequest = await requestNewLyrics(currentPaper, currentSong);
            console.log('REQUEST RESULT: ', recentRequest);
          }}
          buttonPasskeyClick={passkeyClickHandler}
        />

      {:else}

        <PlayerScreen
          paperTitle={loadedLyricData.paper.title}
          paperAuthors={loadedLyricData.paper.authors}
          songTitle={loadedLyricData.song.title}
          songArtist={loadedLyricData.song.artist}
          lyrics={loadedLyricData.lyrics}
          generationId={loadedLyricData.id}
          music={addAuth(new URL(`${loadedLyricData.song.id}.mp3`, new URL(config.collections[currentCollection].music, serverUrl)))}
          doubleClick={() => {
            if (passkey) {
              console.log('Navigating player screen...');
              commandNavigate()
            }
          }}
          back={() => {
            params.delete('id');
            params.delete('paper');
            params.delete('song');
            navigate(false, 'Clearing paper/song/id to go home from playing');
          }}
          showDownloadButton={true}
        />

      {/if}

    {/if}

  {/if}

</main>


<dialog id="passkey-dialog">
  <form method="dialog" autocomplete="off">
    <!-- svelte-ignore a11y_autofocus -->
    <div>
      <label>Passkey: 
        <input autofocus onfocus={(e) => {
          // @ts-ignore
          e.target.select()
        }} autocomplete="one-time-code" enterkeyhint="done" id="passkey" type="password" placeholder="passkey">
      </label>
      <button value="default" onclick={(e) => {
        e.preventDefault();
        // @ts-ignore
        document.querySelector('#passkey-dialog').close('default');
      }}>Set</button>
      <button value="cancel" formmethod="dialog">✕</button> 
    </div>
  </form>
</dialog>


<style>
dialog::backdrop {
  background: rgba(0, 0, 0, 0.5);
  backdrop-filter: blur(10px);
}

dialog button {
  padding: 0;
  color: black;
  display: inline;
  width: auto;
  min-width: auto;
  padding: 0.2em;
}
dialog input, dialog button {
  border: 1px solid black;
  border-radius: 5px;
  margin: 0px 10px;
}
dialog button[value=cancel] {
  border: none;
  float: left;
}
</style>
